import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <FaqSection />
        <IndexSection />
        <MediaSection />
        <CommentsSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
        <UpdatesSection />
        <AboutSection />
        <CardsSection />
        <ContactSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}